import { useNavigate } from "react-router-dom";
import { useOrderTypeContext } from "../Contexts/OrderTypeContext";
import OrderService from "../Services/OrderService";
import { useCartContext } from "../Contexts/CartContext";
import { useLayoutContext } from "../Contexts/LayoutContext";
import { useStoreHook } from "./StoreHook";
import { useTranslation } from "react-i18next";

export const useOrderHook = () => {

    const { t } = useTranslation();
    const { orderType } = useOrderTypeContext();
    const { setCurrentOrder, setShowOrderDetail, setLoadingOrderDetail } = useCartContext();
    const { setMainLoading, setMainLoadingIcon, setMainLoadingIconError, setMainLoadingTitle, setMainLoadingMessage, setMainLoadingCloseButton } = useLayoutContext();
    const { getLinkToHome } = useStoreHook();
    const navigate = useNavigate();

    const getOrderDetail = async (order_id: number) => {
        const payload = {
            order_id: order_id,
        }
        setShowOrderDetail(true);
        setLoadingOrderDetail(true);

        try {
            const orderService = new OrderService(orderType);
            const details = await orderService.detail(payload);

            if (details) {
                setCurrentOrder(details);
            }
        } catch (error) {
            setShowOrderDetail(false);
            setLoadingOrderDetail(false);

            setMainLoading(true);
            setMainLoadingIcon(false);
            setMainLoadingIconError(true);
            setMainLoadingTitle(t('errors.default_title'));
            setMainLoadingMessage(t('errors.default_message'));
            setMainLoadingCloseButton(true);
        } finally {
            setLoadingOrderDetail(false);
        }
    }

    const goToOrderView = (order_id: number) => {
        navigate(`${getLinkToHome()}/order/${order_id}/view`);
    }

    return {
        getOrderDetail,
        goToOrderView
    };
}